import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { GeneratedContentMakeShorterInput, GeneratedContentMakeShorterPayload } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TVariables = GeneratedContentMakeShorterInput;
type TData = GeneratedContentMakeShorterPayload;

export const useContentGenerationShorten = (
  options: Omit<UseMutationOptions<TData, TGenericError, TVariables, unknown>, 'mutationFn'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    mutation generatedContentMakeShorter($input: GeneratedContentMakeShorterInput!) {
      generatedContentMakeShorter(input: $input) {
        success
        errors
        errorCode
        text
      }
    }
  `;

  return useMutation<TData, TGenericError, TVariables, unknown>({
    mutationFn: (input: TVariables): Promise<TData> =>
      client.request({
        data: {
          gql: graphql,
          variables: { input }
        }
      }),
    ...options
  });
};
